/**
 * @desc inventoryCostPushToEbs
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InventoryCostPushToEbsRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/test/inventoryCostPushToEbs`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
